import { Moment } from "moment";
import { OfficeEntity } from "./AdvanceHotDeskingService";
import { agent } from "@shared/services/agent";
import { DATE_FORMAT } from "@shared/utils/DateUtils";


export function getDeskUtilizationForOffice(office: OfficeEntity | undefined, dateFrom: Moment, dateTo: Moment): Promise<DeskUtilizationReport> {
  const officeParam = office ? `officeId=${office.id}&` : '';
  return agent.requests.get(`/api/report/desk/utilization?${officeParam}fromDate=${dateFrom.format(DATE_FORMAT)}&toDate=${dateTo.format(DATE_FORMAT)}`);
}

export interface DeskUtilizationReport {
  officeId: number;
  officeLabel: string;
  totalDesks: number
  totalBookings: number;
  daysInRange: number;
  utilizationPercentage: number;
  floors: FloorDeskUtilization[];
}

export interface FloorDeskUtilization {
  floorId: number;
  floorLabel: string;
  totalDesks: number;
  totalBookings: number;
  daysInRange: number;
  utilizationPercentage: number;
  desks: DeskUtilizationDetail[];
}

export interface DeskUtilizationDetail {
  deskId: number;
  label: string;
  usage: number;
  daysInRange: number;
}

export function getDeskBookingSchedule(office: OfficeEntity | undefined, dateFrom: Moment, dateTo: Moment): Promise<DeskUtilizationReport> {
  const officeParam = office ? `officeId=${office.id}&` : '';
  return agent.requests.get(`/api/report/desk/bookings?${officeParam}fromDate=${dateFrom.format(DATE_FORMAT)}&toDate=${dateTo.format(DATE_FORMAT)}`);
}

export interface DeskBookingSchedule {
  deskId: number;
  label: string;
  floorId: number;
  floorLabel: string;
  bookings: DeskBookingDate[]
}

interface DeskBookingDate {
  date: string;
  am: boolean;
  pm: boolean;
}
